import { _formatDate } from "../../../libs/dateUtils";
import {
  del,
  get,
  getDownload,
  post,
  postNoBody,
  put,
  urlApiTegra,
} from "../../../service/api";
import { TimeWorkClosed } from "../model";

function getTotalWorkedByProjectUsers(
  token: string,
  dataFrom: string,
  dataTo: string,
  userId?: number,
  projectId?: number
) {
  const queryString = `?dateFrom=${_formatDate(dataFrom)}&dateTo=${_formatDate(
    dataTo
  )}${userId ? "&userId=" + userId : ""}${
    projectId ? "&projectId=" + projectId : ""
  }`;
  return get(
    `${urlApiTegra}/time-points/total/project-user${queryString.trim()}`,
    token
  );
}

function getTimeWorkDownload(
  token: string,
  year: string,
  month: string,
  userId?: number,
  projectId?: number
) {
  const queryString = `?year=${year}&month=${month}${
    userId ? "&userId=" + userId : ""
  }${projectId ? "&projectId=" + projectId : ""}`;
  return getDownload(
    `${urlApiTegra}/time-work/download${queryString.trim()}`,
    token
  ).then((data) => data?.text());
}

function getAllTimeWorkList(token: string, year: string, month: string) {
  const queryString = `?year=${year}&month=${month}`;
  return get(`${urlApiTegra}/time-work/list${queryString.trim()}`, token);
}

function getTimeWorkList(
  token: string,
  year: string,
  month: string,
  userId?: number,
  projectId?: number
) {
  const queryString = `?year=${year}&month=${month}${
    userId ? "&userId=" + userId : ""
  }${projectId ? "&projectId=" + projectId : ""}`;
  return get(`${urlApiTegra}/time-work/list${queryString.trim()}`, token);
}

function postTimeWorkClose(token: string, body: TimeWorkClosed) {
  return post(`${urlApiTegra}/time-work/close`, body, token).then((data) =>
    data?.json()
  );
}

function postNotifyType(body: any, token: string) {
  return post(`${urlApiTegra}/monitor`, body, token)
}

function postTimeWorkApproved(token: string, body: any) {
  return put(`${urlApiTegra}/time-work/time-approved`, body, token);
}

function timeWorkNotifyLeadApprove(token: string) {
  return postNoBody(`${urlApiTegra}/monitor-excess/notify-lead-approve`, token);
}

function timeWorkNotifyTimeWorked(token: string, body: any) {
  return post(`${urlApiTegra}/time-work/notify-time-worked`, body, token);
}

function notifyProjectManager(token: string) {
  return postNoBody(`${urlApiTegra}/monitor-excess`, token);
}

function notifyCollaborator(token: string) {
  return postNoBody(`${urlApiTegra}/monitor-missing`, token);
}

function timeWorkDelete(token: string, ids: any[]){
  return del(`${urlApiTegra}/time-work/delete?id=${ids.join(',')}`, token)
}

export {
  getTotalWorkedByProjectUsers,
  postTimeWorkClose,
  getTimeWorkList,
  getTimeWorkDownload,
  postTimeWorkApproved,
  timeWorkNotifyLeadApprove,
  timeWorkNotifyTimeWorked,
  getAllTimeWorkList,
  notifyCollaborator,
  notifyProjectManager,
  timeWorkDelete,
  postNotifyType
};
